// Copyright (c) 2016 Deere & Company

import Registrations, {getDefaultState} from '../state/registrations';
import actions from '../../actions-list';

const deleteRegistration = (state, action) =>
    Registrations.update(state, {
        $set: state.filter(registration => registration.id !== action.registrationID)
    });

const updateRegistrationResults = (state, action) =>
    Registrations.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.DELETE_REGISTRATION_SUCCESS]: deleteRegistration,
        [actions.UPDATE_REGISTRATION_RESULTS]: updateRegistrationResults
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/registration-review/reducers/registrations.js